// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const gtagRegister = () => {
  window.gtag('event', 'Registrazione', {
    event_category: 'Utente',
    event_label: 'https://club.giocamondo.it/register',
    value: 1,
  });
};
